import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const UnselectedCheckbox = (props: IIconProps) => {
  const { width = 16, height = 16, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" fill="white" stroke={color} />
    </svg>
  );
};
export default memo(UnselectedCheckbox);
